import React from "react";
import { withStyles } from '@material-ui/core/styles';
import { Paper, Grid, Button } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import moment from 'moment';
import CustomToolbarSelect from "./CustomToolBarSend";
import ls from 'local-storage';
import Typography from '@material-ui/core/Typography';

const styles = theme => ({
    root: {
        flexGrow: 1,
        overflow: 'hidden',
    },
    button: {
        margin: theme.spacing.unit / 2,
        marginTop: 0,
        marginBottom: 0,
    },
    paper: {
        padding: theme.spacing.unit,
        color: theme.palette.text.secondary,
    },
    tabBar: {
        boxShadow: 'none',
    },
});  

class ClaimsSend extends React.Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.props = props;
    }

    state = {
        sendclaimlist: [],
        batch_id: '',
        sendBtnActive: false,
    };

    getMuiTheme = () => createMuiTheme({
        overrides: {
            MuiTableCell: {
                root: {
                    padding: 0,
                }
            },
            MUIDataTable: {
                responsiveScroll: {
                    paddingLeft: 8,
                    maxHeight: `calc(100vh - 145px)`,
                },
            },
        }
    });

    fetchClaims() {
        if (this._isMounted) {
            this.props.socket.emit("claims_send_list",{authenticator:ls.get("authenticator")});
        }
    };     

    componentDidMount() {
        this._isMounted = true;  
        
        this.fetchClaims();
        
        this.props.socket.on("send_list_result",(d)=>{
            if (this._isMounted) {

                //console.log(d);

                let data = d.claimlist.map((dt, i) => {
                    return [dt.fp17_id, moment(moment(dt.date_submitted, "YYYYMMDDHHmm")).format("DD/MM/YYYY"), 
                            dt.surname, dt.forenames, dt.initials, dt.form_data.pchg, dt.short_desc, dt.uda_weight, '', ''];
                });
                
                this.setState({sendclaimlist: data});

                this.setState({batch_id: d.batchid});

                this.setState({sendBtnActive: false});
                if (this.state.sendclaimlist.length > 0)
                    this.setState({sendBtnActive: true});
            }

            //console.log(this.state.sendclaimlist.length);
        });  

        this.props.socket.on("claims_move_result",(d)=>{
            if (this._isMounted) {
                this.fetchClaims();
            }         
        });    

        this.props.socket.on("send_claims_result",(d)=>{
            if (this._isMounted) {
                this.fetchClaims();
            }         
        });                 

    }

    componentWillUnmount() {
        this._isMounted = false;
    }  

    handleChange = (event, value) => {
        this.setState({ value });
    };

    handleMoveClaims = (e) => {
        //console.log({move: e});
        //console.log(this.state.sendclaimlist);

        let moveList = [];
        let i = 0;
        for (i=0; i<e.data.length; i++)
        {
            moveList.push(this.state.sendclaimlist[e.data[i].dataIndex][0]);
        }

        this.props.socket.emit("claims_move_hold", {list:moveList,authenticator:ls.get("authenticator")});
    }

    sendClaims = (e) => {
        this.setState({sendBtnActive: false});
        this.props.socket.emit("send_claims",{authenticator:ls.get("authenticator")});
    }

    checkResponses = (e) => {
        this.props.socket.emit("check_bsa",{authenticator:ls.get("authenticator")});
    }

    processResponses = (e) => {
        this.props.socket.emit("process_responses",{authenticator:ls.get("authenticator")});
    }    

    render() {
        const { classes } = this.props;
        const { sendclaimlist } = this.state;

        const columns=[
            { name: 'ID', options: {filter: true, sort: true,}},
            { name: 'Date Submitted', options: {filter: true, sort: true,}},
            { name: 'Surname', options: {filter: false, sort: true,}},
            { name: 'Forenames', options: {filter: false, sort: true,}},
            { name: 'Clinician', options: {filter: true, sort: true,}},
            { name: 'Patient Charge', options: {filter: false, sort: true,}},
            { name: 'Band', options: {filter: true, sort: true,}},
            { name: 'UDA', options: {filter: true, sort: true,}},
            { name: 'Category', options: {filter: true, sort: true,}},
            { name: 'Cont', options: {filter: true, sort: true,}},
        ];    

    return (
        <div className={classes.root}>
            <Grid container style={{ padding: 2 }} spacing={1}>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <Button variant="contained" color="primary" className={classes.button} 
                            onClick={this.sendClaims} disabled={!this.state.sendBtnActive}>Send All Claims Now</Button>
                        <Button variant="contained" color="secondary" className={classes.button} onClick={this.checkResponses}>Check Responses</Button>
                        <Button variant="outlined" color="secondary" className={classes.button} onClick={this.processResponses}>Process Responses</Button>
                    </Paper>
                </Grid>  
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <Typography variant="body2" gutterBottom>
                            Click the "Send all claims now" button to send all the bellow to BSA.<br/>
                            If you do not wish to send certain claims, tick them and then click the pause button to move them to the hold.
                        </Typography>
                    </Paper>
                </Grid>                   
                <Grid item xs={12}>
                    <MuiThemeProvider theme={this.getMuiTheme()}>
                        <MUIDataTable
                            data={sendclaimlist}
                            columns={columns}
                            title={'Batch: '+this.state.batch_id}
                            options={{
                                filterType: "dropdown",
                                responsive: "standard",
                                customToolbarSelect: selectedRows => (
                                    <CustomToolbarSelect selectedRows={selectedRows} moveHandler={this.handleMoveClaims} />
                                ),
                                textLabels: {
                                    body: {
                                    noMatch: "No claims to send",
                                    },
                                },
                            }}
                        />   
                    </MuiThemeProvider>                 
                </Grid>
            </Grid>
        </div>    
    );
  }
}

export default withStyles(styles)(ClaimsSend);